import React, { useState } from "react";
import "./styles.css";
import axios from "axios";

/** Mirrors partner-analytics-api/lib/partnerOrgId.js — reject before calling API. */
function isValidPartnerOrgIdForUi(orgId) {
  if (!orgId || typeof orgId !== "string") return false;
  const t = orgId.trim();
  if (t.length === 0 || t.length > 128) return false;
  if (t.includes("..") || t.includes("%")) return false;
  if (/[/\\?#&=\s\u0000-\u001f]/.test(t)) return false;
  if (/[^a-zA-Z0-9._-]/.test(t)) return false;
  if (!/^[a-zA-Z0-9]/.test(t) || !/[a-zA-Z0-9]$/.test(t)) return false;
  return true;
}

function isImpersonationSuccessPayload(data) {
  return (
    data &&
    typeof data === "object" &&
    data.content &&
    String(data.content.impersonateStatus) === "1" &&
    typeof data.impersonationToken === "string" &&
    data.impersonationToken.length > 0
  );
}

const Login = () => {
  const [agentId, setAgentId] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const validateOrgId = async (orgId) => {
    const response = await axios.get(
      `${
        window.REACT_APP_API_BASE_URL
      }should-impersonate?orgId=${encodeURIComponent(orgId)}`,
      {
        withCredentials: true,
        validateStatus: (status) => status >= 200 && status < 500,
      }
    );
    return response;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!agentId.trim()) {
      setError("Please enter your Organization ID");
      return;
    }

    const trimmed = agentId.trim();
    if (!isValidPartnerOrgIdForUi(trimmed)) {
      setError("Invalid organization ID format");
      return;
    }

    setLoading(true);
    try {
      const response = await validateOrgId(trimmed);
      const validationResult = response.data;

      if (response.status >= 400) {
        const msg =
          validationResult?.message ||
          (typeof validationResult === "string"
            ? validationResult
            : "Not authorized");
        setError(msg);
        return;
      }

      if (isImpersonationSuccessPayload(validationResult)) {
        const token = validationResult.impersonationToken;
        if (validationResult.impersonationMintError && !token) {
          setError(
            validationResult.impersonationMintError ||
              "Login could not be completed. Contact support."
          );
          return;
        }
        window.location.href = `${
          window.REACT_APP_API_BASE_URL
        }custom-login?token=${encodeURIComponent(token)}`;
        return;
      }

      if (validationResult?.content?.impersonateStatus === "1") {
        setError(
          validationResult?.impersonationMintError ||
            "Login could not be completed. The API could not store a one-time login ticket in Redis. Check Redis connectivity, or contact support."
        );
        return;
      }

      setError("Unauthorized Organization ID");
    } catch (error) {
      setError(error.response?.data?.message || "Not authorized");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <img
            src={process.env.PUBLIC_URL + "/assets/images/new-jio-logo.svg"}
            alt="Jio Logo"
            className="jio-logo"
          />
          <h1>Welcome to Partner Central Analytics Platform</h1>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="agentId">Organization ID</label>
            <input
              type="text"
              id="agentId"
              value={agentId}
              onChange={(e) => {
                setAgentId(e.target.value);
                setError("");
              }}
              placeholder="Enter your Organization ID"
              className={error ? "error" : ""}
              disabled={loading}
            />
            {error && <span className="error-message">{error}</span>}
          </div>

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
        <footer
          className="wow fadeInUp fixed-bottom"
          data-wow-delay="2.3s"
          data-wow-duration="0.7s"
          style={{ color: "white", fontSize: "12px" }}
        >
          &copy; {new Date().getFullYear()} Reliance Industries Limited. All
          rights reserved.
        </footer>
      </div>
    </div>
  );
};

export default Login;
